import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";

export interface Configuration {
  nCriterionLevel: number | null;
  nExchangeRate: number | null;
  nActionLevel: number | null;
  nThresholdLevel: number | null;
  nDecibelRounding: number | null;
  nDoseRounding: number | null;
  nUncertaintyRounding: number | null;
  tBodyTemperatureC: number | null;
  tBodyTemperatureShiftC: number | null;
  tTemperatureRounding: number | null;
  tClHeavy100: number | null;
  tClHeavy75: number | null;
  tClHeavy50: number | null;
  tClHeavy25: number | null;
  tClLight100: number | null;
  tClLight75: number | null;
  tClLight50: number | null;
  tClLight25: number | null;
  tClModerate100: number | null;
  tClModerate75: number | null;
  tClModerate50: number | null;
  tClModerate25: number | null;
  lWallReflectionLimit: number | null;
  lWorkPlaneReflectionLimit: number | null;
  lLengthRounding: number | null;
  lIcRounding: number | null;
  lLuxRounding: number | null;
  lReflectionRounding: number | null;
  primaryColor: string | null;
  headingColor: string | null;
  goodColor: string | null;
  warningColor: string | null;
  badColor: string | null;
  warningGoodColor: string | null;
  warningBadColor: string | null;
  paperSize: string | null;
  marginIn: number | null;
  timezone: string | null;
  logoUrl: string | null;
  coverImage: boolean | null;
  laboratory: string | null;
  accreditationNumber: string | null;
  approvalNumber: string | null;
  outline: boolean | null;
  sectionDividers: boolean | null;
}

export async function getConfiguration(): Promise<Response<Configuration>> {
  const responseResult = await tryCatch(
    fetch(`${API_BASE_URL}/api/v1/configuracion`, {
      method: "GET",
      credentials: "include",
    })
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err
      ? Err({
          message: `Error al obtener configuración del usuario: ${errorMessageResult.val.message}`,
          devMessage: errorMessageResult.val.message,
        })
      : Err({
          message: errorMessageResult.val.message,
          devMessage: errorMessageResult.val.devMessage,
        });
  }

  const dataResult = await tryCatch(response.json());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}
